module.exports = "./img/c4aba16b32c2fa4d8c32cd01f30718e5.jpg";